import { gql } from '@apollo/client/core'
import { FREE_ANSWER_FRAGMENT } from './fragments'
import { PAGINATION_FRAGMENT } from 'graphql/mails/fragments'
import { FreeAnswer } from 'globals/models/FreeAnswer'
import { Pagination } from 'globals/models/Mail'

export interface FreeAnswersDataType {
  freeAnswers: {
    freeAnswers: FreeAnswer[],
    pagination: Pagination
  }
}

export const FREE_ANSWERS = gql`
  query freeAnswers(
    $pagination: PaginationInput!,
    $filters: [FilterInput!]
  ) {
    freeAnswers(
      pagination: $pagination,
      filters: $filters
    ) {
      freeAnswers {
        ...FreeAnswerFragment
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${FREE_ANSWER_FRAGMENT}
  ${PAGINATION_FRAGMENT}
`

export interface MissingFreeAnswerSubmitsDataType {
  missingFreeAnswerSubmits: FreeAnswer[]
}

export const MISSING_FREE_ANSWER_SUBMITS = gql`
  query missingFreeAnswerSubmits {
    missingFreeAnswerSubmits {
      id
      addressId
      addressName
      forwardedAt
    }
  }
`

export const UPSERT_FREE_ANSWER = gql`
  mutation freeAnswerUpsert(
    $id: ID
    $forwardedAt: ISO8601Date!
    $trackingNumber: String
    $addressId: ID!
  ) {
    freeAnswerUpsert(
      id: $id
      forwardedAt: $forwardedAt
      trackingNumber: $trackingNumber
      addressId: $addressId
    ) {
      freeAnswer {
        ...FreeAnswerFragment
      }
    }
  }
  ${FREE_ANSWER_FRAGMENT}
`
